export default __webpack_public_path__ + "static/media/flow_2.1c556667.jpg";